export const ANALYTICS_ACTION_NAME = 'cardfinder_exit_intent_modal_select';
export const ANALYTICS_EXIT_INTENT_ACTION_SECTION = 'cardfinder_exit_intent_modal';
